import { Dispatch } from "redux";
import { DropdownItem } from "../../types/observation";
import { setObservationViewFilters } from "../../store/slices/observationSlice";

/**
 * Handles changes to the observation view filters
 * @param key The filter key being changed
 * @param value The new value for the filter
 * @param dispatch Redux dispatch function
 */
export const handleViewFilterChange = (
  key: string,
  value: DropdownItem | DropdownItem[] | null,
  dispatch: Dispatch
) => {
  console.log(`View Filter Changed: ${key}`, value);

  // Map the filter keys to the updated backend field names
  const keyMapping: { [key: string]: string } = {
    observationType: "observationType",
    shift: "shiftNumber",
    role: "roleObserved",
    progress: "status",
    createdBy: "createdBy",
    modifiedBy: "modifiedBy",
    period: "period",
    week: "week",
  };

  // Use the mapped key if it exists, otherwise use the original key
  const mappedKey = keyMapping[key] || key;

  // Update local state
  if (value) {
    const selectedItem = Array.isArray(value) ? value[0] : value;
    if (selectedItem) {
      // Update observationViewFilters in observationSlice when there's a value change
      dispatch(
        setObservationViewFilters({
          [mappedKey]: selectedItem.displayText || "",
        })
      );
    }
  } else {
    // Handle clearing the filter
    dispatch(
      setObservationViewFilters({
        [mappedKey]: "",
      })
    );
  }
};
